module.exports = __webpack_public_path__ + "static/media/anardoniBadgeDarkPersian.6c4cbb36.png";